<template>
  <section>
    <div>
      <el-form :inline="true">
        <el-form-item label="工程名称">
          <el-input v-model="filters.projectName" placeholder="工程名称" @change="getReturAndTransferRecord(1)"></el-input>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input v-model="filters.code" placeholder="单据编号" @change="getReturAndTransferRecord(1)"></el-input>
        </el-form-item>
        <el-form-item label="车号">
          <el-input v-model="filters.vehicleErpCode" placeholder="车号" @change="getReturAndTransferRecord(1)"></el-input>
        </el-form-item>
        <el-form-item label="起止时间">
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.isPY" @change="getReturAndTransferRecord(1)" placeholder="是否盘盈">
            <el-option label="所有" :value="-1"></el-option>
            <el-option label="盘盈" :value="1"></el-option>
            <el-option label="退转" :value="0"></el-option>
            <el-option label="废料" :value="100"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getReturAndTransferRecord(1)">
            查询
          </el-button>

        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="ReturAndTransferRecord" highlight-current-row v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true" show-summary
      :summary-method="getSummaries">
      <el-table-column prop="OldOutMasterCode" label="原出货单">
        <template slot-scope="scope">
          <div>原单：<el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.OldOutMasterCode }}
            </el-link>
            <br />
            新单：{{ scope.row.NewOutMasterCode }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="OldProjectName" label="工程信息">
        <template slot-scope="scope">
          <div>原工程： {{ scope.row.OldProjectName }}
            <br />
            新工程：{{ scope.row.NewProjectName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="OldVehicleErpCode" label="车辆信息">
        <template slot-scope="scope">
          <div>原车号： {{ scope.row.OldVehicleErpCode }}
            <br />
            新车号：{{ scope.row.NewVehicleErpCode }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="OldDriverName" label="司机信息">
        <template slot-scope="scope">
          <div>原司机： {{ scope.row.OldDriverName }}
            <br />
            新司机：{{ scope.row.NewDriverName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="OldQuantityDelivery" label="方量信息">
        <template slot-scope="scope">
          <div>原发货： {{ scope.row.OldQuantityDelivery }}
            <br />
            新发货：{{ scope.row.NewQuantityDelivery }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ToType" label="转入类型">
        <template slot-scope="scope">
          <el-tag :type="scope.row.ToType == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.ToType == 0 ? "转入车辆" : "转入出货单" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="RemainQuantity" label="退转方量"></el-table-column>

      <el-table-column prop="ReturnType" label="转料类型">
        <template slot-scope="scope">
          <el-tag :type="scope.row.ReturnType == 0 ? 'success' : 'info'" disable-transitions>
            {{
              scope.row.ReturnType == 0
                ? "盘盈转料"
                : scope.row.ReturnType == 200
                  ? "整车转料"
                  : "废料"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="PYQuantity" label="盘盈方量"></el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
      <el-table-column prop="CreateUser" label="创建者"></el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
    <!-- 详情 -->
    <el-dialog width="90%" title="退转详情" :visible.sync="isShowDetail" v-model="isShowDetail"
      :close-on-click-modal="false" append-to-body>
      <table class="table-bordered">
        <tr>
          <td>退转类型</td>
          <td>
            <el-tag :type="DetaildM.ReturnType == 0 ? 'success' : 'info'" disable-transitions>
              {{
                DetaildM.ReturnType == 0
                  ? "盘盈转料"
                  : DetaildM.ReturnType == 200
                    ? "整车转料"
                    : "废料"
              }}
            </el-tag>
            <el-tag :type="DetaildM.ToType == 0 ? 'success' : 'info'" disable-transitions>
              {{
                DetaildM.ToType == 0
                  ? "转入车辆"
                  : DetaildM.ToType == 100
                    ? "生成出货单"
                    : "生成出货单"
              }}
            </el-tag>
          </td>

          <td>操作方量</td>
          <td>{{ DetaildM.RemainQuantity }}</td>
        </tr>
        <tr>
          <td>原出货单</td>
          <td>{{ DetaildM.OldOutMaster.Code }}</td>
          <td>新出货单</td>
          <td>{{ DetaildM.NewOutMaster.Code }}</td>
        </tr>
        <tr>
          <td>原强度</td>
          <td>{{ DetaildM.OldOutMaster.GradeName }}</td>
          <td>新强度</td>
          <td>{{ DetaildM.NewOutMaster.GradeName }}</td>
        </tr>
        <tr>
          <td>原工程</td>
          <td>{{ DetaildM.OldOutMaster.ProjectName }}</td>
          <td>新工程</td>
          <td>{{ DetaildM.NewOutMaster.ProjectName }}</td>
        </tr>
        <tr>
          <td>原部位</td>
          <td>{{ DetaildM.OldOutMaster.ProjectPart }}</td>
          <td>新部位</td>
          <td>{{ DetaildM.NewOutMaster.ProjectPart }}</td>
        </tr>
        <tr>
          <td>原发货方量</td>
          <td>{{ DetaildM.OldOutMaster.QuantityDelivery }}</td>
          <td>新发货方量</td>
          <td>{{ DetaildM.NewOutMaster.QuantityDelivery }}</td>
        </tr>
        <tr>
          <td>原生产方量</td>
          <td>混凝土：{{ DetaildM.OldOutMaster.TQuantity }}砂浆：{{ DetaildM.OldOutMaster.SQuantity }}</td>
          <td>新生产方量</td>
          <td>混凝土：{{ DetaildM.NewOutMaster.TQuantity }}砂浆：{{ DetaildM.NewOutMaster.SQuantity }}</td>
        </tr>
        <tr>
          <td>原车号</td>
          <td>{{ DetaildM.OldOutMaster.VehicleErpCode }}</td>
          <td>新车号</td>
          <td>{{ DetaildM.NewOutMaster.VehicleErpCode }}</td>
        </tr>
        <tr>
          <td>原司机</td>
          <td>{{ DetaildM.OldOutMaster.DriverName }}</td>
          <td>新司机</td>
          <td>{{ DetaildM.NewOutMaster.DriverName }}</td>
        </tr>
      </table>
    </el-dialog>
  </section>
</template>

<script>
//引入whsetting.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/returandtransferrecord";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        startTime: "",
        endTime: "",
        projectName: "",
        code: "",
        vehicleErpCode: "",
        page: 1,
        intPageSize: 20,
      },
      ReturAndTransferRecord: [],
      total: 0,
      listLoading: false,
      sels: [],
      sumData: {},
      isShowDetail: false,
      DetaildM: { OldOutMaster: {}, NewOutMaster: {} },
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    getSummaries(param) {
      var sums = [];
      sums[0] = "合计";
      sums[1] = "";
      sums[2] = "";
      sums[3] = "";
      sums[4] = "";
      sums[5] = "";
      sums[6] = this.sumData.RemainQuantity;
      sums[7] = "";
      sums[8] = this.sumData.PYQuantity;
      sums[9] = "";
      sums[10] = "";
      sums[11] = "";

      return sums;
    },
    //单击表格行事件绑
    // 定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReturAndTransferRecord();
    },
    // 显示窗口
    handleDetail(row) {
      this.DetaildM = row;
      this.isShowDetail = !this.isShowDetail;
    },
    //获取列表
    getReturAndTransferRecord(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      api.getReturAndTransferRecordListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.ReturAndTransferRecord = res.data.response.data;
        this.sumData = res.data.response.responsesum;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.filters.page = 1;
      this.getReturAndTransferRecord();
    },
    formatDateADD(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate() - 7); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDateADD(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDateADD(endDate);

    this.getReturAndTransferRecord();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
